import React from 'react';
import PropTypes from 'prop-types';

import { getRedeemedVoucherCode } from 'constants/localStorageManager';

const RedeemedVoucher = ({ message, token }) => {
  const redeemedCodes = getRedeemedVoucherCode() || [];
  const isReedeemedCouponCode = redeemedCodes.includes(token);
  const displayMessage = isReedeemedCouponCode
    ? `The voucher has been redeemed!`
    : message;

  return (
    <div className="container mt-3">
      <div className="redeemed col-md-6 mx-auto bg-white styled-box-shadow p-5">
        <div className="p-1 w-50 mx-auto text-center redeemed-text">
          {displayMessage}
        </div>
      </div>
    </div>
  );
};

RedeemedVoucher.propTypes = {
  message: PropTypes.string.isRequired,
  token: PropTypes.string.isRequired,
};

export default RedeemedVoucher;



// WEBPACK FOOTER //
// ./src/components/userSurveyReward/RedeemedVoucher.js